/**
 * Vertragsmanagement API
 * REST-Api für das Conergos Vertragsmanagement Tool.
 *
 * OpenAPI spec version: 0.1.0
 * Contact: marius.junak@scorpius-forge.de
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Injectable } from '@angular/core';
import { InstallerPassTypeEnum } from '@bo-client/shared/models/installerPassDto';
import { networkOperatorList } from '@bo-client/core/api/data-lists/network-operator-list';
import { SupplyAppointmentPartDayStatusEnum } from '@bo-client/activation-management/shared/models/commissioningModel';
import { BusinessPartnerTypeEnum } from '@bo-client/business-partners/model/businessPartnerType';
import { Observable, of } from 'rxjs';
import { HttpHapService } from '@bo-client/core/http/http-hap.service';
import { ConfigService } from '@bo-client/config/config.service';
import { combineLatestWith, map, shareReplay } from 'rxjs/operators';
import { SalutationsModel } from '@bo-client/shared/constants/salutations';
import { uri } from '@bo-client/shared/constants/uri';
import {
  CommissioningListFilterTypeConstant,
  CommissioningPowerMeterTypeConstant
} from '@bo-client/activation-management/commissioning/forms/commissioning-data-enum';
import { DataShareService } from '@bo-client/shared/services/data-share.service';
import { CodeListValue } from '@bo-client/shared/models/codeListValue';
import { MailTemplateTypeConst } from '@bo-client/shared/models/mail-template-type';

export interface MailTemplateType {
  value: string;
  displayName: string;
  /**
   * Voll qualifizierte Entitätsklasse, für die das Backend das Template vorsieht (`TemplateType`
   * in netz-services); `…core.models.RequestEntity` kennzeichnet allgemeine Templates.
   */
  entityClass?: string;
}

/** Eintrag von `GET /meta/template-types` (Backend: `features/shared/Option`). */
export interface Option {
  value: string;
  title: string;
  entityClass?: string;
}

type NamedValue = {
  value: string;
  displayName: string;
};

@Injectable()
export class MetaService {
  getAreaText(area: string): string | undefined {
    return this.areas.find((a) => a.value === area)?.displayName;
  }
  public salutationValues$: Observable<SalutationsModel[]> = of([
    {
      title: 'Frau',
      id: '0001',
      type: 'Person'
    },
    {
      title: 'Herr',
      id: '0002',
      type: 'Person'
    },
    {
      title: 'Privatperson',
      id: '0004',
      type: 'Person'
    },
    {
      title: 'Firma',
      id: '0003',
      type: 'Organisation'
    },
    {
      title: 'Herr und Frau',
      id: '0006',
      type: 'Person'
    },
    {
      title: 'Herren',
      id: '0009',
      type: 'Person'
    },
    {
      title: 'Herrn / Herrn',
      id: '0012',
      type: 'Person'
    },
    {
      title: 'Frau / Frau',
      id: '0013',
      type: 'Person'
    },
    {
      title: 'Baugenossenschaft',
      id: '0017',
      type: 'Organisation'
    },
    {
      title: 'Bauherrengemeinsch.',
      id: '0018',
      type: 'Organisation'
    },
    {
      title: 'Eigentümergemeinsch.',
      id: '0019',
      type: 'Organisation'
    },
    {
      title: 'Erbengemeinschaft ',
      id: '0020',
      type: 'Organisation'
    }
  ]);

  public reactivePowerProvisioningMethods$ = of([
    {
      value: 'Q_U_STANDARD_CURVE',
      displayName: 'Q(U)-Standard-Kennlinie'
    },
    {
      value: 'COS_PHI_P_STANDARD_CURVE',
      displayName: 'Cos Phi (P)-Standard-Kennlinie'
    },
    {
      value: 'FIXED_DISPLACEMENT_FACTOR_COS_PHI',
      displayName: 'fester Verschiebungsfaktor cos Phi'
    }
  ]);

  public usageTypes$ = of([
    {
      value: 'G',
      displayName: 'Gewerbe'
    },
    {
      value: 'H',
      displayName: 'Haushalt'
    },
    {
      value: 'I',
      displayName: 'Industrie'
    },
    {
      value: 'L',
      displayName: 'Landwirtschaft'
    },
    {
      value: 'OE',
      displayName: 'Öffentliches Gebäude'
    },
    {
      value: 'S',
      displayName: 'Sonstiges'
    }
  ]);

  /**
   * LESS_20_DEGREE("< 20 Grad"),
   *   BETWEEN_20_40_DEGREE("20 - 40 Grad"),
   *   BETWEEN_40_60_DEGREE("40 - 60 Grad"),
   *   FACADE_INTEGRATED("Fassadenintegriert"),
   *   FOLLOWING("Nachgeführt");
   */
  public tiltValues$ = of([
    {
      value: 'LESS_20_DEGREE',
      displayName: '< 20 Grad'
    },
    {
      value: 'BETWEEN_20_40_DEGREE',
      displayName: '20 - 40 Grad'
    },
    {
      value: 'BETWEEN_40_60_DEGREE',
      displayName: '40 - 60 Grad'
    },
    {
      value: 'FACADE_INTEGRATED',
      displayName: 'Fassadenintegriert'
    },
    {
      value: 'FOLLOWING',
      displayName: 'Nachgeführt'
    }
  ]);
  /**
   * SOUTH("Süd"),
   *   SOUTH_WEST("Süd-West"),
   *   SOUTH_EAST("Süd-Ost"),
   *   WEST("West"),
   *   EAST_WEST("Ost-West"),
   *   EAST("Ost"),
   *   NORTH_WEST("Nord-West"),
   *   NORTH_EAST("Nort-Ost"),
   *   NORTH("Nord"),
   *   FOLLOWED("Nachgeführt");
   */
  public orientationValues$ = of([
    {
      value: 'SOUTH',
      displayName: 'Süd'
    },
    {
      value: 'SOUTH_WEST',
      displayName: 'Süd-West'
    },
    {
      value: 'SOUTH_EAST',
      displayName: 'Süd-Ost'
    },
    {
      value: 'WEST',
      displayName: 'West'
    },
    {
      value: 'EAST_WEST',
      displayName: 'Ost-West'
    },
    {
      value: 'EAST',
      displayName: 'Ost'
    },
    {
      value: 'NORTH_WEST',
      displayName: 'Nord-West'
    },
    {
      value: 'NORTH_EAST',
      displayName: 'Nord-Ost'
    },
    {
      value: 'NORTH',
      displayName: 'Nord'
    },
    {
      value: 'FOLLOWED',
      displayName: 'Nachgeführt'
    }
  ]);

  /**
   * public enum BatteryTechnologyEnum implements Titled {
   *   BATTERY('Batterie'),
   *   PUMP('Pumpspeicher'),
   *   AIR_PRESSURE('Druckluft'),
   *   NAME('Schwungrad'),
   *   FLY_WHEEL('Sonstige');
   */
  batteryTechnology$ = of([
    {
      value: 'BATTERY',
      displayName: 'Batterie'
    },
    {
      value: 'PUMP',
      displayName: 'Pumpspeicher'
    },
    {
      value: 'AIR_PRESSURE',
      displayName: 'Druckluft'
    },
    {
      value: 'NAME',
      displayName: 'Schwungrad'
    },
    {
      value: 'FLY_WHEEL',
      displayName: 'Sonstige'
    }
  ]);

  batteryType$ = of([
    {
      value: 'BLE',
      displayName: 'Blei-Batterie'
    },
    {
      value: 'HOC',
      displayName: 'Hochtemperaturbatterie'
    },
    {
      value: 'LIT',
      displayName: 'Lithium-Batterie'
    },
    {
      value: 'NIC',
      displayName: 'Nickel-Cadmium- / Nickel-Metallhydridbatterie'
    },
    {
      value: 'RED',
      displayName: 'Redox-Flow-Batterie'
    },
    {
      value: 'STG',
      displayName: 'Sonstige Batterie'
    }
  ]);

  voltageLevels$ = of([
    {
      value: 'Low',
      displayName: 'Niederspannung'
    },
    {
      value: 'Middle',
      displayName: 'Mittelspannung'
    },
    {
      value: 'High',
      displayName: 'Hochspannung'
    }
  ]);

  feederConnectionStandards$ = of([
    {
      value: 'VDE4105',
      displayName: 'VDE-AR-N 4105'
    },
    {
      value: 'VDE4110',
      displayName: 'VDE-AR-N 4110'
    }
  ]);

  rateLimitingTypes$ = of([
    {
      value: 'Direct',
      displayName: 'Einzelsteuerung als SteuVE'
    },
    {
      value: 'EMS',
      displayName: 'Steuerung über EMS'
    },
    {
      value: 'NotControlled',
      displayName: 'nicht steuerbar'
    }
  ]);

  filteredRateLimitingTypes$: Observable<{ value: string; displayName: string }[]>;

  constructor(
    private httpService: HttpHapService,
    private configService: ConfigService,
    private dataShareService: DataShareService
  ) {
    // Anzeigename und Sortierung entstehen ausschließlich hier im Client, damit alle
    // Template-Auswahlen (Workflow-Regel-Modal, Mail-Templates der Mandanten-Einstellungen)
    // dieselben, auffindbaren Bezeichnungen in derselben Reihenfolge zeigen. Gespeichert und
    // übertragen wird immer `value`: das Enum TemplateType in netz-services wird numerisch über
    // seinen Ordinalwert persistiert, eine Umbenennung oder Umsortierung dort würde bestehende
    // Datensätze auf andere Templates zeigen lassen.
    this.allTemplates$ = httpService.getTyped<Option[]>(`/meta/template-types`).pipe(
      map((data: Option[]): MailTemplateType[] =>
        data
          .map((template) => ({
            value: template.value,
            displayName: MailTemplateTypeConst[template.value]?.displayName ?? template.title,
            entityClass: template.entityClass
          }))
          .sort((a, b) => (a.displayName ?? '').localeCompare(b.displayName ?? '', 'de'))
      ),
      shareReplay(1)
    );

    this.filteredRateLimitingTypes$ = this.rateLimitingTypes$.pipe(
      combineLatestWith(this.dataShareService.tenantConfig$),
      map((x) => {
        if (x[1].gridRegistration.p14aRateLimitingTypeOptions)
          return x[0].filter((y) => x[1].gridRegistration.p14aRateLimitingTypeOptions.includes(y.value));

        return x[0];
      })
    );
  }

  public codeListValues$(fieldName: string, tenantId: string): Observable<CodeListValue[]> {
    return this.httpService
      .getTyped<CodeListValue[] | null>(uri.codeListValues + '/' + fieldName + '/' + tenantId)
      .pipe(
        map((data) => {
          return data || [];
        })
      );
  }

  public networkOperatorList = new networkOperatorList();

  public getFoundationTypeOptions(): NamedValue[] {
    return [
      {
        value: 'none',
        displayName: 'Keine'
      },
      {
        value: 'cobble',
        displayName: 'Pflaster/Platten'
      },
      {
        value: 'asphalt',
        displayName: 'Asphalt'
      }
    ];
  }

  public getBuildingTypes(): { name: string; value: string }[] {
    return [
      {
        name: 'Ein-/Zwei-Familienhaus',
        value: 'Single'
      },
      {
        name: 'Mehr-Familienhaus',
        value: 'Multi'
      },
      {
        name: 'Gewerbe',
        value: 'Business'
      }
    ];
  }

  public getRegionValues(): NamedValue[] {
    return this.regions;
  }

  regions = [
    {
      value: '',
      displayName: 'Alle'
    },
    {
      value: 'TBS',
      displayName: 'TBS'
    },
    {
      value: 'TRS',
      displayName: 'TRS'
    },
    {
      value: 'TBW',
      displayName: 'TBW'
    }
  ];

  public getAreaValues(): NamedValue[] {
    return this.areas;
  }

  // Todo: refactor areatypes
  /**
   * Sparten der Hausanschlüsse. `value` ist der Name des Backend-Enums `Area` (netz-services) und wird
   * unverändert als Filterwert an `/orders/filter` bzw. `/orders/filter/v2` gesendet — ein Wert außerhalb
   * dieses Enums lässt die Filterabfrage scheitern. Quelle für den Sparten-Filter der Hausanschlussliste
   * (v1 und v2) und die Sparten-Auswahl der Kalkulationspositionen im Hausanschluss-Detail.
   */
  areas = [
    {
      value: 'Power',
      displayName: 'Strom'
    },
    {
      value: 'Gas',
      displayName: 'Erdgas'
    },
    {
      value: 'LWL',
      displayName: 'Leerrohr'
    },
    {
      value: 'LWLK',
      displayName: 'Glasfaser'
    },
    {
      value: 'Water',
      displayName: 'Wasser'
    },
    {
      value: 'Heat',
      displayName: 'Fernwärme'
    }
  ];

  public getQuestionTypes(): NamedValue[] {
    return this.questionTypes;
  }

  questionTypes = [
    {
      value: 'doc',
      displayName: 'Dokumenten-Upload'
    },
    {
      value: 'question',
      displayName: 'Bestätigung (Checkbox)'
    },
    {
      value: 'license',
      displayName: 'Fremdausweis'
    },
    {
      value: 'renewDoc',
      displayName: 'Dokument für Ausweisverlängerung'
    },
    {
      value: 'renewQuestion',
      displayName: 'Frage für Ausweisverlängerung'
    }
  ];

  public getTmInstallerTypes(): NamedValue[] {
    return this.tmInstallerTypes;
  }

  tmInstallerTypes: { value: string; displayName: string }[] = [
    {
      value: InstallerPassTypeEnum.pass,
      displayName: 'Installateurausweis'
    },
    {
      value: InstallerPassTypeEnum.license,
      displayName: 'Gastgenehmigung'
    }
  ];

  public getTmInstallerTypesForQuestions(): NamedValue[] {
    return this.tmInstallerTypesForQuestions;
  }

  tmInstallerTypesForQuestions = [
    {
      value: 'pass',
      displayName: 'Installateurausweis'
    },
    {
      value: 'license',
      displayName: 'Gastgenehmigung'
    },
    {
      value: 'renew',
      displayName: 'Gast-Installateurausweis Verlängerung'
    },
    {
      value: 'renewPass',
      displayName: 'Installateurausweis Verlängerung'
    },
    {
      value: 'renewLicense',
      displayName: 'Gastausweis Verlängerung'
    }
  ];

  public getDocumentTypes(): NamedValue[] {
    return this.documentTypes;
  }

  documentTypes = [
    {
      value: 'plaene',
      displayName: 'Plan'
    },
    {
      value: 'connectionDrawing',
      displayName: 'Anschlusszeichnung'
    },
    {
      value: 'pictures',
      displayName: 'Bild'
    },
    {
      value: 'eigentuemer',
      displayName: 'Eigentümer Bestätigung'
    },
    {
      value: 'steuer',
      displayName: 'Ust. Bestätigung'
    },
    {
      value: 'vertrag',
      displayName: 'Vertrag'
    },
    {
      value: 'dienstbarkeit',
      displayName: 'Dienstbarkeit'
    },
    {
      value: 'bbs_approval',
      displayName: 'Bestätigung Schornsteinfeger'
    },
    {
      value: 'consumptionUnder30kw',
      displayName: 'Nachweis Eigenverbrauch'
    },
    {
      value: 'gridRegistrationDoc',
      displayName: 'Netzanmeldung'
    },
    {
      value: 'hoehenschnitt',
      displayName: 'Höhenschnitt'
    },
    {
      value: 'grundriss',
      displayName: 'Grundriss'
    },
    {
      value: 'datenerfassung',
      displayName: 'Datenerfassung'
    },
    {
      value: 'stornierung',
      displayName: 'Stornierung'
    },
    {
      value: 'construction_file',
      displayName: 'Bauakte'
    },
    {
      value: 'schriftverkehr',
      displayName: 'Schriftverkehr'
    },
    {
      value: 'gutschrift',
      displayName: 'Gutschrift'
    },
    {
      value: 'vollmacht',
      displayName: 'Vollmacht'
    },
    {
      value: 'kampfmittel_dokumente',
      displayName: 'Kampfmitteldokumente'
    }
  ];

  public allTemplates$: Observable<MailTemplateType[]>;

  public getMailTemplateTypes(): MailTemplateType[] {
    return this.mailTemplateTypes;
  }

  public getAllTemplateTypes(): MailTemplateType[] {
    return this.allTemplates;
  }

  allTemplates: MailTemplateType[] = [
    {
      value: 'DEFAULT',
      displayName: 'Default'
    },
    {
      value: 'OFFER_REQUEST_CONFIRMATION',
      displayName: 'Bestätigung Angebotsanfrage'
    },
    {
      value: 'ORDER_CONFIRMATION',
      displayName: 'Bestellbestätigung'
    },
    {
      value: 'ORDER_CONFIRMATION_REQUEST',
      displayName: 'Anfrage Vertragsbestätiung durch Kunden'
    },
    {
      value: 'ORDER_CONFIRMATION_LETTER',
      displayName: 'Auftragsbestätigung - Anschreiben'
    },
    {
      value: 'ORDER_REQUEST_LETTER',
      displayName: 'Angebot - Anschreiben'
    },
    {
      value: 'CANCELLATION_LETTER',
      displayName: 'Absage - Anschreiben'
    },
    {
      value: 'BREAKUP_NOTICE',
      displayName: 'Aufbruchanzeige - Anschreiben'
    },
    {
      value: 'BUYING_CONTRACT',
      displayName: 'Kaufvertrag - Hausanschlusskasten'
    },
    {
      value: 'NEW_MESSAGE_NOTIFICATION',
      displayName: 'Chat - Neue Nachricht'
    },
    {
      value: 'MAIL_CONFIRMATION_REQUEST',
      displayName: 'Mail Bestätigung - Mail'
    },
    {
      value: 'PASSWORD_CHANGE_REQUEST',
      displayName: 'Passwort ändern - Mail'
    },
    {
      value: 'TM_WELLCOME_ADMIN_INSTALLATEUR',
      displayName: 'Inst. - Wilkommensnachricht'
    },
    {
      value: 'TM_INSTALLER_PASS',
      displayName: 'Inst. - Ausweis - HTML'
    },
    {
      value: 'TM_PASS_REJECTED',
      displayName: 'Inst. Ausweis abgelehnt'
    },
    {
      value: 'ORDER_CONFIRMATION_DELETE',
      displayName: 'HA-Anfrage - Geloescht'
    },
    {
      value: 'COM_BBS_APPROVAL',
      displayName: 'Inbtr. Schornsteinfeger Best.'
    },
    {
      value: 'COM_VALID',
      displayName: 'Inbtr. freigegeben.'
    },
    {
      value: 'COM_SUPPLY_DATE_APPOINTMENT',
      displayName: 'Inbtr. Wunschdatum anfordern.'
    },
    {
      value: 'COM_NEW_SUPPLY_APPOINTMENT_AGREED',
      displayName: 'Inbtr. New Wunschdatum vereinbaren.'
    },
    {
      value: 'TM_PASS_VALID',
      displayName: 'Inst. Ausweis freigegeben'
    },
    {
      value: 'TM_PASS_RENEWED',
      displayName: 'Inst. Ausweis verlängert'
    },
    {
      value: 'TM_GRID_REGISTRATION_VALID',
      displayName: 'Netzanmeldung freigegeben'
    },
    {
      value: 'TM_GRID_REGISTRATION_DECLINED',
      displayName: 'Netzanmeldung abgelehnt'
    },
    {
      value: 'TM_GRID_REGISTRATION_REQUEST_VALIDATION',
      displayName: 'Netzanmeldung Genehmigung angefordert'
    },
    {
      value: 'MAIL_FOOTER',
      displayName: 'Mail Footer'
    },
    {
      value: 'CUSTOMER_CSS',
      displayName: 'Mail CSS'
    },
    {
      value: 'FEEDER_CONTRACT',
      displayName: 'Einspeiservertrag'
    },
    {
      value: 'CONSTRUCTION_FILE',
      displayName: 'Bauakte'
    },
    {
      value: 'DATA_SHEET_HA_GASWATER',
      displayName: 'Erfassungsblatt Gas Wasser'
    },
    {
      value: 'ORDER_REVOCATION',
      displayName: 'Widerrufsformular'
    },
    {
      value: 'ORDER_REVOCATION_CONFIRMATION',
      displayName: 'Bestätigung Widerruf'
    },
    {
      value: 'ORDER_CONFIRMATION_INTRO',
      displayName: 'ORDER_CONFIRMATION_INTRO'
    },
    {
      value: 'OFFER_REQUEST_INTRO',
      displayName: 'OFFER_REQUEST_INTRO'
    },
    {
      value: 'COMMISSIONING_CHECK',
      displayName: 'Inbetriebnahme-Überprüfungsprotokoll'
    },
    {
      value: 'PV_REGISTRATION_FORM',
      displayName: 'PV Meldeformular'
    },
    {
      value: 'PLUGIN_GRID_REGISTRATION_APPROVED_METER',
      displayName: 'Steckerfertige Anlage - Freigabe mit Zählerwechsel'
    },
    {
      value: 'EXPLOSIVE_ORDNANCE_DISPOSAL_INFO',
      displayName: 'Anfrage Kampfmittelbeseitigung'
    }
  ];

  public getBusinessPartnerRoles(): {
    value: BusinessPartnerTypeEnum;
    displayName: string;
    show: boolean;
  }[] {
    return this.businessPartnerRoles;
  }

  businessPartnerRoles = [
    {
      value: BusinessPartnerTypeEnum.SERVICE_PROVIDER,
      displayName: 'Dienstleister',
      show: true
    },
    {
      value: BusinessPartnerTypeEnum.STATE_BUILDING_AUTHORITY,
      displayName: 'Landesbauamt',
      show: true
    },
    {
      value: BusinessPartnerTypeEnum.BUILDING_AUTHORITY,
      displayName: 'Bauverwaltung',
      show: true
    },
    {
      value: BusinessPartnerTypeEnum.INSTALLER,
      displayName: 'Installateur',
      show: true
    },
    {
      value: BusinessPartnerTypeEnum.CHIMNEY_SWEEPER,
      displayName: 'Schornsteinfeger',
      show: true
    }
  ];

  mailTemplateTypes: MailTemplateType[] = [
    // {
    //   value: 'DEFAULT',
    //   displayName: 'approvede Nachricht',
    // },
    // {
    //   value: 'OFFER_REQUEST_CONFIRMATION',
    //   displayName: 'Bestätigung Angebotsanfrage',
    // },
    {
      value: 'ORDER_CONFIRMATION',
      displayName: 'Bestellbestätigung'
    },
    // {
    //   value: 'ORDER_CONFIRMATION_REQUEST',
    //   displayName: 'Anfrage Vertragsbestätiung durch Kunden',
    // },
    {
      value: 'ORDER_CONFIRMATION_LETTER',
      displayName: 'Auftragsbestätigung - Anschreiben'
    },
    {
      value: 'ORDER_REQUEST_LETTER',
      displayName: 'Angebot - Anschreiben'
    },
    {
      value: 'CANCELLATION_LETTER',
      displayName: 'Absage - Anschreiben'
    },
    {
      value: 'BREAKUP_NOTICE',
      displayName: 'Aufbruchanzeige - Anschreiben'
    },
    {
      value: 'ORDER_REVOCATION',
      displayName: 'Widerrufsformular'
    },
    {
      value: 'ORDER_REVOCATION_CONFIRMATION',
      displayName: 'Bestätigung Widerruf'
    },
    {
      value: 'BUYING_CONTRACT',
      displayName: 'Kaufvertrag'
    },
    {
      value: 'FEEDER_CONTRACT',
      displayName: 'Einspeiservertrag'
    },
    {
      value: 'CONSTRUCTION_FILE',
      displayName: 'Bauakte'
    },
    {
      value: 'DATA_SHEET_HA_GASWATER',
      displayName: 'Erfassungsblatt Gas Wasser'
    },
    {
      value: 'COMMISSIONING_CHECK',
      displayName: 'Inbetriebnahme-Überprüfungsprotokoll'
    },
    {
      value: 'PV_REGISTRATION_FORM',
      displayName: 'PV Meldeformular'
    },
    {
      value: 'CONNECTION_CONTRACT_MAIL',
      displayName: 'Netzanschlussvertrag Mail'
    },
    {
      value: 'CONNECTION_CONTRACT',
      displayName: 'Netzanschlussvertrag Dokument'
    },
    {
      value: 'NDAV_GAS_GRID_CONNECTION_CONTRACT',
      displayName: 'NDAV Niederdruckanschlussvertrag Gas'
    },
    {
      value: 'EXPLOSIVE_ORDNANCE_DISPOSAL_INFO',
      displayName: 'Anfrage Kampfmittelbeseitigung'
    },
    {
      value: 'ORDER_CONFIRMATION_LETTER_TEMPWATER',
      displayName: 'Bestellbestätigung Bauwasser'
    },
    {
      value: 'ORDER_CONFIRMATION_LETTER_TEMPPOWER',
      displayName: 'Bestellbestätigung Baustrom'
    },
    {
      value: 'ORDER_CONFIRMATION_LETTER_GAS',
      displayName: 'Bestellbestätigung Gas - Anschreiben'
    },
    {
      value: 'ORDER_CONFIRMATION_LETTER_WATER',
      displayName: 'Bestellbestätigung Wasser - Anschreiben'
    },
    {
      value: 'ORDER_CONFIRMATION_LETTER_POWER',
      displayName: 'Bestellbestätigung Strom - Anschreiben'
    },
    {
      value: 'ORDER_CONFIRMATION_METER_COLUMN',
      displayName: 'Bestellbestätigung Strom - Zähleranschlusssäule'
    },
    {
      value: 'ORDER_CONFIRMATION_WATER_METER_Q34',
      displayName: 'HA - Print Bestellbestätigung - Wasserzähler Q3_4'
    },
    {
      value: 'ORDER_CONFIRMATION_WATER_METER_Q310',
      displayName: 'HA - Print Bestellbestätigung - Wasserzähler Q3_10'
    },
    {
      value: 'ORDER_CONFIRMATION_GAS_HA_KASTEN',
      displayName: 'HA - Print Bestellbestätigung - Gas HA-Kasten'
    }
  ];

  public getMailTemplateFormats(): NamedValue[] {
    return this.mailTemplateFormats;
  }

  mailTemplateFormats = [
    {
      value: 'HTML_THYMELEAF',
      displayName: 'Html Template (Thymeleaf)'
    },
    {
      value: 'DOCX_STAMPER',
      displayName: 'Word Template (Stamper)'
    },
    {
      value: 'FAST_REPORT',
      displayName: 'FastReport'
    },
    {
      value: 'FILLABLE_PDF',
      displayName: 'Ausfüllbares PDF'
    }
  ];

  public getActivitiesStates(): NamedValue[] {
    return this.activitiesStates;
  }

  activitiesStates = [
    {
      value: '',
      displayName: 'Alle'
    },
    {
      value: 'OPEN',
      displayName: 'Ja'
    }
  ];

  public getSupplyAppointmentPartDayStatus(): NamedValue[] {
    return this.supplyAppointmentPartDayStatus;
  }

  supplyAppointmentPartDayStatus = [
    {
      value: '',
      displayName: 'Auswählen'
    },
    {
      value: SupplyAppointmentPartDayStatusEnum.Morning,
      displayName: 'Vormittags'
    },
    {
      value: SupplyAppointmentPartDayStatusEnum.Afternoon,
      displayName: 'Nachmittags'
    }
  ];

  public getTiefBauStates(): NamedValue[] {
    return this.tiefBauStates;
  }

  tiefBauStates = [
    {
      value: '',
      displayName: 'Alle'
    },
    {
      value: 'YES',
      displayName: 'Mit allen Tiefbauarbeiten'
    },
    {
      value: 'NO',
      displayName: 'Ohne Tiefbauarbeiten'
    },
    {
      value: 'PUBLIC_ONLY',
      displayName: 'Ohne Tiefbauarbeiten im privaten Bereich'
    }
  ];

  public getNetworkOperator() {
    return this.networkOperatorList.networkOperatorData;
  }

  public getRelatedGRtoCRTypes(): NamedValue[] {
    return this.relatedGRtoCRTypes;
  }

  private relatedGRtoCRTypes = [
    {
      value: 'noApproved',
      displayName: 'Nicht freigegeben'
    }
  ];

  getActionFilterOptions() {
    return [...CommissioningListFilterTypeConstant, ...CommissioningPowerMeterTypeConstant];
  }
}
